<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">{{ title }}</span>

  @if (!loading) {
    <button
      mat-icon-button
      mat-dialog-close
      type="button"
      [attr.aria-label]="'receipts.ui.chiudi' | transloco"
      class="close-button"
    >
      <i class="fa-regular fa-xmark"></i>
    </button>
  }
</h2>

<mat-dialog-content class="receipt-content">
  @if (loading) {
    <div class="receipt-loading" role="status" aria-live="polite">
      <ui-loading-spinner />
      <span class="body-medium-emphasized">{{ 'receipts.ui.attendiIlCompletamentoDellOperazione' | transloco }}</span>
      <span class="body-small">{{ 'receipts.ui.laConfermaDellIncassoEInCorso' | transloco }}</span>
    </div>
  } @else if (errorMessage) {
    <div class="receipt-operation-error" role="alert">
      <div class="receipt-operation-error-icon" aria-hidden="true">
        <i class="fa-regular fa-xmark"></i>
      </div>
      <span class="label-medium-emphasized">{{ 'receipts.ui.operazioneNonCompletata' | transloco }}</span>
      <span class="body-small">{{ errorMessage }}</span>
    </div>
  } @else {
    <div class="receipt-success">
      <div class="receipt-success-icon" aria-hidden="true">
        <i class="fa-regular fa-check"></i>
      </div>

      <span class="label-medium-emphasized">{{ 'receipts.ui.ricevutaEmessa' | transloco }}</span>
      <span class="label-small">N° {{ data.numero }}</span>
    </div>

    <div class="receipt-card">
      <div class="receipt-row">
        <span class="body-small">{{ 'receipts.ui.cliente2' | transloco }}</span>
        <span class="body-small-emphasized receipt-value">{{ data.cliente }}</span>
      </div>

      <div class="receipt-row">
        <span class="body-small">{{ 'receipts.ui.metodo2' | transloco }}</span>
        <span class="body-small-emphasized receipt-value">{{ data.metodo }}</span>
      </div>

      <div class="receipt-row">
        <span class="body-small">{{ 'receipts.ui.importo2' | transloco }}</span>
        <span class="body-small-emphasized receipt-value">{{ formatAmount(data.importo) }}</span>
      </div>

      @if (data.accontiSpese.length > 0) {
        <div class="receipt-allocated-items receipt-advance-expenses">
          <span class="body-small">{{ 'receipts.ui.accontiSpese' | transloco }}</span>

          @for (item of data.accontiSpese; track $index) {
            <span class="body-small-emphasized">
              {{ item.codiceCliente }} ({{ formatAmount(item.importo) }})
            </span>
          }
        </div>
      }

      <div class="receipt-allocated-items">
        <span class="body-small">{{ 'receipts.ui.partiteImputate' | transloco }}</span>

        @for (item of data.partiteImputate; track item.documento) {
          <span class="body-small-emphasized">
            {{ item.documento }} ({{ item.descrizione }} {{ formatAmount(item.importo) }})
          </span>
        }
      </div>
    </div>

    @if (data.emailInviata) {
      <div class="receipt-email-message body-small">
        {{ 'receipts.ui.laRicevutaEStataInviataAllaCasellaDiPosta' | transloco: { value0: (data.email ? ': ' + data.email : '') } }}
      </div>
    } @else {
      <div class="receipt-email-message receipt-email-message-error body-small" role="alert">
        {{ 'receipts.ui.nonEStatoPossibileInviareLaRicevutaViaEMail' | transloco: { value0: (data.email ? (" " + ('receipts.ui.allaCasellaDiPosta' | transloco) + " ") + data.email : '') } }}
      </div>
    }
  }
</mat-dialog-content>

@if (!loading) {
  <mat-dialog-actions class="receipt-actions">
    @if (errorMessage) {
      <button matButton="filled" type="button" (click)="close()">{{ 'receipts.ui.chiudi' | transloco }}</button>
    } @else {
      <button matButton="filled" type="button" (click)="tornaAllaHome()">{{ 'receipts.ui.tornaAllaHome' | transloco }}</button>
      <button matButton="outlined" type="button" (click)="data.onDownloadPdf?.()">{{ 'receipts.ui.scaricaPdf' | transloco }}</button>
    }
  </mat-dialog-actions>
}
